import {
    lazyInitializeAndWarmupSearchAnswers,
    lazyInitializeData,
} from 'owa-search-answer-deeplink';

export async function deepLinkSearchAnswerRouteHandler() {
    await lazyInitializeData.importAndExecute();
    lazyInitializeAndWarmupSearchAnswers.importAndExecute();
}
